import { render, staticRenderFns } from "./RationInfoDialog.vue?vue&type=template&id=2b6aede8&scoped=true&"
import script from "./RationInfoDialog.vue?vue&type=script&lang=js&"
export * from "./RationInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./RationInfoDialog.vue?vue&type=style&index=0&id=2b6aede8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6aede8",
  null
  
)

export default component.exports